/** 判断 API 错误是否为 404 */
export const isNotFoundError = (error: unknown): boolean =>
  Boolean(
    error &&
    typeof error === "object" &&
    "status" in error &&
    (error as { status?: number }).status === 404,
  );
